import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import { useParams } from 'react-router';

import AccountOverview from './AccountOverview';
import SectionMessage from 'components/SectionMessage/SectionMessage';

import { getCardDisplayName } from 'utilities/helpers';
import { creditAccountPath } from 'utilities/routes';
import config from 'config';

const ArchivedCreditOverview = ({ account }) => {
  const { customerId } = useParams();

  return (
    <AccountOverview
      accountTitle={getCardDisplayName(account)}
      cardLast4={account?.cardDetails?.last4}
      enableNavigation={true}
      navigateTo={creditAccountPath(customerId, account?.id)}
    >
      <SectionMessage
        icon={ContainerOutlined}
        text="Account Archived"
        size="small"
        style={{ marginTop: 'var(--spacing-xl)' }}
        body={
          <Typography.Text type="secondary" align="center">
            Information within Mission Control is limited.
          </Typography.Text>
        }
        buttons={[
          {
            onClick: (event) => {
              event.preventDefault();
              window.open(
                `${config.SNOWFLAKE_STREAMLIT_URI}?streamlit-account_id=${account?.id}`,
                '_blank',
              );
            },
            text: 'View Historical Data',
            size: 'small',
          },
        ]}
      />
    </AccountOverview>
  );
};

export default ArchivedCreditOverview;
